import React from "react";
import SpendingDemandListView, {
  ItemSpending,
} from "./SpendingDemandListView/SpendingDemandListView";

import { dateConverter } from "../../../../../utils/dateConverter";

import { useSpendingDemandManager } from "../../../hooks";
import { ReadableStatus, spendingDemandStatusRawToReadableStatus } from "../../../utils/spenpdingDemandStatusConverter";
import EmptyListIcon from "../../../../../components/atoms/EmptyListIcon/EmptyListIcon";
import Loader from "../../../../../components/atoms/Loader/Loader";
import { SpendingDemand } from "../../../types/spendingDemand.types";
import { useNavigate } from "react-router-dom";
import PaginationV2 from "../../../../../components/organismes/PaginationV2/PaginationV2";
import UserInfo from "../../../../user/components/UserInfo";
import ProjectInfo from "../../../../project/components/ProjectInfo";
import CreditTotalRenderer from "./SpendingDemandListView/CreditTotalRenderer";
import SpendingTotalRenderer from "./SpendingDemandListView/SpendingTotalRenderer";
import CollabPayedRenderer from "./SpendingDemandListView/CollabPayedRenderer";
import OrgPayedRenderer from "./SpendingDemandListView/OrgPayedRenderer";
import AcompteRenderer from "./SpendingDemandListView/AcompteRenderer";
import useQueryURL from "../../../../../utils/useQueryURL";
import { buildSpendingDemandDetailLink } from "../../../utils/spendingDemandListNavigation";


const ToProcessStatus : ReadableStatus  = {
  status: "A traiter",
  color: {
    light: "#f4df8c8b",
    normal: "#f1c92b",
    dark: "#5d5535",
  },
  JWayIcon: "thunder",
}


export  function SpendingDemandListPresenterV2({withSelectMode, linkBase, forUser}: {withSelectMode?: boolean, linkBase?: string, forUser?: boolean}) {
  const {
    allSpendingDemandList: { data: spendingDemandListData, isLoading, setPage },
    selectSpendingDemand,
    unSelectSpendingDemand,
    selectAllSpendingDemands,
    unSelectAllSpendingDemands,
    isAllSpendingDemandsSelected,
    isSomeSpendingDemandsSelected,
    isSpendingDemandeSelected,
  } = useSpendingDemandManager();
  const { setQueryValue, currentLocation } = useQueryURL();

  const pagination = spendingDemandListData?.pagination;


  const navigate = useNavigate();


  const handleClick = (spendingDemandId: string) => {
    navigate(buildSpendingDemandDetailLink('/spending_demand', spendingDemandId, currentLocation, 'manager'))
  }

  const handleCheck = (spendingDemand: SpendingDemand) => {
    if (isSpendingDemandeSelected(spendingDemand.spending_demand_id)) {
      unSelectSpendingDemand(spendingDemand);
    } else {
      selectSpendingDemand(spendingDemand);
    }
  }

  const handleSelectAll = () => {
    if (formated && formated.length > 0) {
      const allSpendingDemands = spendingDemandListData?.data || [];
      selectAllSpendingDemands(allSpendingDemands);
    }
  }

  const handleUnselectAll = () => {
    const currentPageDemands = spendingDemandListData?.data || [];
    unSelectAllSpendingDemands(currentPageDemands);
  }

  const handleChangePageSize = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const nextPageSize = Number(event.target.value);
    if (Number.isNaN(nextPageSize)) return;
    setQueryValue({
      "spendingdemandmanager-pageSize": nextPageSize.toString(),
      "spendingdemandmanager-page": "1",
    });
  };
  

  

  const formated: ItemSpending[] | undefined =
    spendingDemandListData?.data?.map((spending) => {
      const isToProcess = spending.is_to_process
      const statusObject = spendingDemandStatusRawToReadableStatus(
        spending.spending_demand_status,
        "for-user",
        isToProcess
      );

      return {
        id: spending.spending_demand_id,
        title: spending.spending_demand_desc,

        userFullNameRenderer: () => <><UserInfo id={spending.spending_demand_user as any as string} info="username" limitText={10}/> <UserInfo id={spending.spending_demand_user as any as string} info="lastname" limitText={10}/> </>,
        projectNameRenderer: () => <><ProjectInfo id={spending.spending_demand_project as any as string} info="project_name" limitText={10}/> </>,
        creditTotalRenderer: () => <CreditTotalRenderer spendingDemandId={spending.spending_demand_id} />,
        collabPayedRenderer: () => <CollabPayedRenderer spendingDemandId={spending.spending_demand_id} />,
        orgPayedRenderer: () => <OrgPayedRenderer spendingDemandId={spending.spending_demand_id} />,
        acompteRenderer: () => <AcompteRenderer spendingDemandId={spending.spending_demand_id} />,
        spendingTotalRenderer: () => <SpendingTotalRenderer spendingDemandId={spending.spending_demand_id} />,
        createdDate: dateConverter(spending.spending_demand_date),
        grossAmmount: spending.spending_demand_amountTTC,
        status: statusObject.status,
        projectName: spending.spending_demand_project,
        spendingDemandType: spending.spending_demand_type,
        boxId: spending.spending_demand_box_association_id,
        spendingDemandLastTeamFrom: spending.last_team_from_by_process_by?.[0]?.team_id,
        spendingDemandComptableTeam: spending.spending_demand_comptable_team,
        spendingDemandReadableId: spending.spending_demand_readable_id,
        pinColor:
          spendingDemandStatusRawToReadableStatus(
            spending.spending_demand_status,
            "general"
          ).color.normal || undefined,
        withPin: isToProcess,
        colorStatus: isToProcess && spending.spending_demand_status === "WAITING_VALIDATION" ? {
          backgroundColor: ToProcessStatus.color.light,
          color: ToProcessStatus.color.dark,
          iconType: ToProcessStatus.JWayIcon
        } :{
          backgroundColor: statusObject.color.light,
          color: statusObject.color.dark,
          iconType: statusObject.JWayIcon
          
        },
        isChecked: isSpendingDemandeSelected(spending.spending_demand_id),
        onCheck: () => handleCheck(spending as any as SpendingDemand),
        onClick: () => handleClick(spending.spending_demand_id)
      };
    });

  if (isLoading) {
    return <Loader paddingTop="20%" centered />;
  }
  if (!formated) {
    return <EmptyListIcon message="Une erreur est survenue" />;
  }
  if (formated && formated.length === 0) {
    return <EmptyListIcon message="Aucune demande de dépense trouvée" />;
  }


  return (
    <>
      <SpendingDemandListView 
        spendingList={formated || []} 
        isCheckMode={withSelectMode} 
        noUser={forUser}
        onSelectAll={handleSelectAll}
        onUnselectAll={handleUnselectAll}
        isAllSelected={spendingDemandListData?.data ? isAllSpendingDemandsSelected(spendingDemandListData.data) : false}
        isSomeSelected={spendingDemandListData?.data ? isSomeSpendingDemandsSelected(spendingDemandListData.data) : false}
        totalCount={pagination?.total_count}
      />
      <PaginationV2
        currentPage={pagination?.current_page}
        lastPage={pagination?.total_pages}
        setCurrentPage={setPage}
      />
      <div style={{ display: "flex", justifyContent: "center", marginTop: "8px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "0.85rem", color: "#666" }}>
          <span>Par page</span>
          <select
            value={pagination?.page_size || 10}
            onChange={handleChangePageSize}
            style={{
              padding: "4px 8px",
              borderRadius: "6px",
              border: "1px solid #d0d0d0",
              backgroundColor: "#fff",
              color: "#333",
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>
          <span>demandes</span>
        </div>
      </div>
    </>
  );
}
